import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';

class Nav extends React.PureComponent {
    state = {
        data: [],
        isFixed: false,
        current: 0,
    };

    componentDidMount() {
        const data = [];
        const domArr = document.querySelectorAll('[data-title]');

        Array.from(domArr).forEach(item => {
            data.push(item.attributes['data-title'].value);
        });

        this.setState({
            data,
        });

        this.unHandleSrcoll = addEventListener(window, 'scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.unHandleSrcoll();
    }

    // 兼容 ie7 的 offsetTop 获取方法
    getOffsetTop = dom => {
        let offsetTop = dom.offsetTop;

        if (dom.offsetParent) {
            offsetTop += this.getOffsetTop(dom.offsetParent);
        }

        return offsetTop;
    };

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        // 兼容各主流浏览器
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        let current = 0;
        const domArr = document.querySelectorAll('[data-title]');

        Array.from(domArr).every((item, index) => {
            const offsetTop = this.getOffsetTop(item);

            if (offsetTop > currentTop || offsetTop === currentTop) {
                current = index;

                return false;
            } else if (index === domArr.length - 1) {
                current = index;

                return false;
            }

            return true;
        });

        this.tabsTop = this.getOffsetTop(domArr[0]);

        if (currentTop > this.tabsTop) {
            this.setState({ isFixed: true, current });
        } else {
            this.setState({ isFixed: false, current });
        }
    };

    scrollToItem = e => {
        const domArr = document.querySelectorAll('[data-title]');
        const current = Number(e.currentTarget.attributes['data-index'].value);
        const top = this.getOffsetTop(domArr[current]);

        scrollTo(0, top);

        this.setState({ current });
    };

    /**
     * 渲染组件
     */
    render() {
        const { data, isFixed, current } = this.state;

        return (
            <div className={isFixed ? styles.fix_nav_box : styles.nav_box}>
                {data.map((item, index) => (
                    <div
                        key={index}
                        className={current === index ? styles.current_box : styles.item_box}
                        data-index={index}
                        onClick={this.scrollToItem}>
                        <span>{item}</span>
                    </div>
                ))}
            </div>
        );
    }
}

export default errorBoundary(Nav);
